import React from 'react';

import * as styles from './ProductCardSkeleton.styles';

/**
 * A placeholder occupying exactly the space a `ProductCard` will, for the
 * moments before a listing's products arrive.
 *
 * It takes no props: it stands in for a product nobody knows anything about
 * yet, so there is nothing to vary. Like the card, it fills the width and the
 * height it is given.
 *
 * Hidden from assistive technology. A row of these carries no information a
 * screen reader can use, and the surface showing them announces that it is
 * loading once, rather than six times.
 */
export const ProductCardSkeleton = () => (
  <div aria-hidden css={styles.card} data-testid="product-card-skeleton">
    <span css={styles.image} />

    <div css={styles.body}>
      <div css={styles.details}>
        <span css={styles.partner} />
        <div css={styles.titleLines}>
          <span css={styles.titleLine} />
          <span css={styles.titleLineShort} />
        </div>
        <span css={styles.price} />
      </div>

      <hr css={styles.divider} />

      <div css={styles.deliverySlot}>
        <span css={styles.deliveryLabel} />
        <span css={styles.deliveryDate} />
      </div>
    </div>
  </div>
);

ProductCardSkeleton.displayName = 'ProductCardSkeleton';
